import { LoadingSpinner } from 'components/spinners';
import { Disclaimer, FormattedUnitValue } from 'components/text';
import { FitLineVoucherIcon } from 'libs/icons/svg-icons/svgs/fitline-voucher';
import { useTranslation } from 'libs/translations';
import AuthenticationService from 'services/AuthenticationService';

import { useWalletAccount } from '../hooks/useWalletAccount';

export function WalletBalance() {
  const {
    data: wallet,
    isLoading,
    error
  } = useWalletAccount(AuthenticationService.user.userId);

  const { t } = useTranslation();

  return (
    <section className="rounded-md bg-secondary p-md md:px-xl md:py-lg shadow-md space-y-sm">
      <h2 className="text-primary">{t('Current Balance')}</h2>
      <div className="flex flex-row gap-sm items-center">
        <span className="text-fitlineVoucherRed">
          <FitLineVoucherIcon size={48} />
        </span>
        {isLoading && <LoadingSpinner smallSize className="text-primary" />}
        {!isLoading && wallet && (
          <p className="text-4xl line-clamp-1 text-ellipsis overflow-hidden">
            {!isLoading && wallet && (
              <FormattedUnitValue
                unit={wallet.currency}
                value={wallet.availableBalance}
              />
            )}
          </p>
        )}
        {((!isLoading && !wallet) || error) && (
          <Disclaimer message={'Something went wrong.'} type="error" />
        )}
      </div>
    </section>
  );
}
